import { z } from 'zod';

import { LosId, PaymentDueId } from '../../BrandedIds';
import { zodTemporalInstant, zodTemporalPlainDate } from '../../Temporal';
import { zodBrandedString, zodBrandedUuid } from '../../utils';

export const ExportablePaymentDue = z
  .object({
    id: zodBrandedUuid<PaymentDueId>(),
    loanId: zodBrandedString<LosId>(),

    dueDate: zodTemporalPlainDate,
    total: z.number(),
    principal: z.number(),
    interest: z.number(),
    escrow: z.number(),
    isFulfilled: z.boolean(),
    amountRemaining: z.number(),
    createdAt: zodTemporalInstant,
  })
  .meta({ title: 'PaymentDue' });
export type ExportablePaymentDue = z.infer<typeof ExportablePaymentDue>;
